import { User } from '../models/User';

/**
 * Fields that should be returned for the logged user
 */
export const AuthenticatedUserFields =
    'id,email,salesman_id,phone,verified,customer_id,factory_id,factory_name,first_name,' +
    'last_name,full_name,thumbnail,language_code,user_view,user_role,roles{id,name},' +
    'customer{id,user_id,salesman_id,salesman_email,organization_name,credit,location_id,location,shipping_locations,' +
    'category{id,name,slug,image{thumbnail_path,file_path}}},is_wholesaler_rep,wholesaler{id,company_name,logo,lakeshore_id}';

/**
 * Authenticated user object
 */
export class AuthenticatedUser extends User {}
